export default {
  app: {
    privacy: {
      policy: '隱私政策',
      expansive: '使用 Expansive 即表示您同意 Expansive 的 {action}',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: '工作階段已過期',
    sessionExpiredDescription: '您的工作階段已過期。請重新登入以繼續使用應用程式。',
  },
  components: {
    appContainer: {
      chooseLanguage: '選擇語言',
      chooseLanguageDescription: '選擇您偏好的應用程式語言。這將更改介面和內容的語言。',
    },
    userSelection: {
      cancel: '取消',
      createNewUser: '沒有我的名字',
      newUser: '新使用者',
      selectAnExistingUser: '選擇現有使用者',
      selectUserHint: '選擇現有使用者或建立新使用者以繼續。',
      startTypingToSearch: '開始輸入...',
    },
    verification: {
      codeVerification: {
        continue: '繼續',
        header: '輸入現場存取碼',
        invalidCode: '驗證碼無效，請再試一次。',
      },
      geoVerification: {
        continueWithoutVerifying: '不驗證位置繼續',
        enterSiteAccessCode: '輸入現場存取碼',
        locationNotEnabledOrAvailable: '為什麼我會看到這個？',
        notAvailable: {
          description: '此裝置不支援 GPS 位置。',
          header: '位置不受支援',
        },
        notEnabled: {
          description: '位置服務未啟用或未授予權限。',
          header: '位置未啟用',
        },
        notVerified: {
          description: 'GPS 顯示您不在現場。',
          header: '位置未驗證',
        },
        tryAgain: '再試一次',
        unavailable: {
          description: '我們無法驗證您的 GPS 位置。',
          header: '位置無法取得',
        },
        unknown: {
          description: '我們無法判斷您的位置。',
          header: '未知位置',
        },
        verified: {
          description: 'GPS 顯示您在現場。',
          header: '位置已驗證',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: '找不到資產',
        emptyDescription: '此工單沒有相關資產。',
        warrantyParts: '零件保固到期',
        serialNumber: '序號',
        none: '<無>',
      },
      updates: {
        emptyTitle: '找不到更新',
        emptyDescription: '此工單沒有更新。',
        unknownUser: '未知使用者',
        none: '無',
        addComment: {
          buttonLabel: '新增評論',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: '危害',
          no: '否',
          yes: '是',
        },
      },
    },
    attachmentsList: {
      attachments: '附件',
      documents: '文件',
      siteDocuments: '現場文件',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: '危害',
        induction: '入場教育',
        safeToProceed: '可安全進行',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: '到期日期',
        activeSessions: '進行中的工作階段',
        activeSessionsDescription: '您已經簽到以下工單。必須先簽出這些工單才能簽入新工單。',
        resumeSession: '繼續',
        startTime: '開始時間',
        unexpectedErrorTitle: '發生非預期錯誤',
        unexpectedErrorMessage: '建立工作階段時發生非預期錯誤。請稍後再試。',
        engineerNotFound: '找不到工程師',
        engineerNotFoundDescription: '您嘗試簽到的工程師在系統中找不到。請聯絡管理員。',
      },
      verification: {
        code: {
          description: '請向現場管理員或指定聯絡人取得 4 位數驗證碼以簽到。',
        },
        geo: {
          continue: '繼續',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff: '請向現場經理或指定聯絡人取得存取碼以完成您的訪問。',
            checkOut: '簽出',
            completeBeforeLeaving: '請在離開前完成下列表單。',
            continue: '繼續',
            noResolutionSelected: '請選擇解決方案後再繼續。',
            quoteRequired: {
              hint: '拜訪完成，後續報價',
              label: '需要報價',
            },
            returnVisitRequired: {
              hint: '我們將再次回訪完成',
              label: '需要回訪',
            },
            serviceCompleted: {
              hint: '無需進一步處理',
              label: '服務已完成',
            },
            uploadCheckout: '上傳檔案、照片或影片',
            visitNotes: '拜訪備註',
            workOrderResolution: '工單解決方案',
            enterNotes: '請在此輸入備註...',
            errors: {
              timedOut: '逾時，已超過30秒。請再試一次。',
              closingSession: '關閉工作階段時發生錯誤',
            },
          },
          success: {
            description:
              '感謝您拜訪 {site}。| {site} 尚有 1 張未結工單。| {site} 尚有 {count} 張未結工單。',
            endVisit: '結束拜訪',
            header: '您已成功簽出',
            viewWorkOrders: '簽入其他工單',
          },
          verification: {
            code: {
              description: '請向現場管理員或指定聯絡人取得 4 位數驗證碼以簽出。',
              continue: '繼續',
            },
            geo: {
              checkOut: '簽出',
              continue: '繼續',
            },
          },
        },
        detail: {
          assets: '資產',
          call: '撥打電話',
          checkOut: '簽出',
          closed: '已結案',
          details: '詳細資訊',
          dueBy: '到期日期',
          manageEngineers: '管理工程師',
          notAvailable: '無法取得',
          pointOfContact: '聯絡人',
          siteAccessTimes: '現場開放時間',
          siteAccessInstructions: '訪問說明',
          siteAddress: '現場地址',
          siteNotes: '現場備註',
          siteTelephone: '現場電話',
          siteLocation: '現場位置',
          updates: '更新',
          more: '更多',
          mismatchErrorTitle: '工單錯誤',
          mismatchErrorMessage: '您嘗試存取的工單與目前簽入的工單不符。請檢查工單後再試。',
          siteDocuments: '現場文件',
          validFrom: '有效起始日',
          validUntil: '有效截止日',
          documentName: '文件名稱',
          documentType: '文件類型',
          attachments: '工單檔案',
          download: '下載',
          workDetails: '工作細節',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: '新增協助工程師',
            assistantEngineers: '協助工程師',
            description: '為安全起見，請填寫現場所有工程師姓名。',
            editMainEngineer: '編輯主要工程師',
            errors: {
              creatingEngineer: '建立工程師時發生錯誤',
              creatingSession: '建立工作階段時發生錯誤',
            },
            header: '現場工程師',
            mainEngineer: '主要工程師',
            newAssistantEngineer: '輸入全名',
            next: '下一步',
            removeEngineer: '移除工程師',
            selectExistingAssistantEngineer: '開始輸入姓名',
          },
          index: {
            description: '為安全起見，請填寫現場所有工程師姓名。',
            errorCreatingEngineer: '建立工程師失敗，請再試一次。',
            header: '現場工程師',
            hintMainEngineer: '輸入主要工程師全名',
            newMainEngineer: '新主要工程師',
            next: '下一步',
            selectExistingMainEngineer: '選擇現有主要工程師',
            yes: '是',
            no: '否',
            mainEngineerLabel: '您是主要工程師嗎？',
          },
        },
        index: {
          callUsOn: '請致電 {phoneNumber}',
          description: '找不到您要的內容嗎？',
          dueBy: '到期日期',
          header: '選擇工單',
          notAvailable: '無法取得',
          searchWorkOrders: '搜尋工單...',
        },
        manageEngineers: {
          manageEngineers: '管理工程師',
          notWorking: '非現場人員',
          pause: '暫停',
          resume: '恢復',
          workingNow: '現場人員',
          startTime: '開始時間',
          endTime: '結束時間',
          duration: '時長',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: '意見回饋',
            feedbackDescription: '請針對本工單提供意見，以協助我們提升服務品質。',
            feedbackLabel: '意見',
            filesLabel: '附件',
            submissionLabel: '提交意見',
          },
          hazards: {
            back: '返回',
            hazards: '危害',
            next: '下一步',
            no: '否',
            noTasksForHazard: '此危害無需執行任何任務。',
            yes: '是',
          },
          induction: {
            continue: '繼續',
            induction: '入場教育',
          },
          index: {
            checkIn: '簽到',
            description: '請針對所選工作完成下列風險評估。',
            fail: '處理工單啟動檢查失敗。',
            haltMessage: '偵測到潛在風險。請停止作業、檢視安全指引並聯絡主管。',
            header: '啟動工作檢查',
            endVisit: '結束拜訪',
            leaveFeedback: '留下意見',
          },
          safeToProceed: {
            continue: '繼續',
            safeToProceed: '可安全進行',
          },
        },
      },
    },
    index: {
      title: '歡迎',
      description: '請掃描您所在地的 QR 碼以開始。',
    },
    login: {
      errorTitle: '發生非預期錯誤',
      errorMessage: '發生非預期錯誤。請重新掃描 QR 碼。',
    },
    unauthenticated: {
      welcome: {
        title: '歡迎來到 {site}',
        description: '在顯示任何工單前，我們需要驗證您的資料。請點擊下方按鈕繼續。',
        next: '繼續',
      },
      index: {
        errorTitle: '發生非預期錯誤',
        errorMessage: '發生非預期錯誤。請重新掃描 QR 碼。',
      },
      contractor: {
        title: '您服務於哪家公司？',
        contractor: '承包商',
        contractorLabel: '開始輸入公司名稱',
        contractorHint: '請輸入三個字元以上以顯示結果',
        defaultSelectPlaceholder: '--請選擇--',
        next: '下一步',
      },
      user: {
        title: '您是誰？',
        cancel: '取消',
        createNewUserLabel: '沒有我的名字',
        existingUserLabel: '開始輸入您的姓名',
        existingUserHint: '請輸入三個字元以上以顯示結果',
        newUserLabel: '請輸入全名',
        next: '下一步',
        user: '使用者',
      },
      verification: {
        methods: {
          add: {
            add: '新增驗證方式',
            defaultSelectPlaceholder: '--請選擇--',
            emailLabel: '電子郵件',
            existingMethodWarning: '您已有待管理員審核的驗證方式申請。新增將覆蓋原申請。',
            method: '方式',
            methodLabel: '方式',
            mobileCountryHint: '請選擇國碼',
            mobileCountryLabel: '手機國碼',
            mobileHint: '請輸入手機號碼',
            mobileLabel: '手機',
            title: '新增驗證方式',
          },
          confirm: {
            confirm: '確認',
            description: '請確認您的驗證方式以繼續。',
            label: '輸入驗證碼',
            resend: '重新發送',
            resendPrompt: '沒收到驗證碼？',
            title: '確認驗證方式',
          },
          confirmed: {
            description: '待管理員審核通過後，您即可使用此驗證方式驗證身份。',
            forceApproval: '審核前無法存取工單。',
            nonForceApproval: '審核期間，您可繼續以受限權限存取工單。',
            nonForceApprovalButtonLabel: '以受限權限繼續',
            title: '等待審核',
          },
          addNew: '新增驗證方式',
          description: '我們需驗證您的身份以提供完整工單存取權限。',
          email: '電子郵件',
          hint: '我們將發送連結至您選擇的驗證方式，完成驗證後可取得完整工單權限。如需更改現有驗證方式，請聯絡管理員。',
          label: '選擇驗證方式',
          next: '下一步',
          pendingHint: '等待管理員審核',
          sms: '簡訊',
          title: '驗證',
        },
        optional: {
          hint: '驗證您的資料可取得完整工單權限',
          label: '您要驗證您的資料嗎？',
          next: '下一步',
          no: '否',
          noHint: '我不想驗證資料，僅以受限權限存取工單',
          title: '驗證',
          yes: '是',
          yesHint: '我要驗證資料並取得完整工單權限',
        },
        sent: {
          description: '登入連結已發送至 {identifier}。請點擊連結完成登入。',
          title: '登入連結已發送',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: '昨天',
      today: '今天',
      days: {
        monday: '星期一',
        tuesday: '星期二',
        wednesday: '星期三',
        thursday: '星期四',
        friday: '星期五',
        saturday: '星期六',
        sunday: '星期日',
      },
      months: {
        january: '一月',
        february: '二月',
        march: '三月',
        april: '四月',
        may: '五月',
        june: '六月',
        july: '七月',
        august: '八月',
        september: '九月',
        october: '十月',
        november: '十一月',
        december: '十二月',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: '發生錯誤',
      message: '請重新掃描 QR 碼。',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: '未知使用者',
      },
      none: '無',
      types: {
        stateTransition: '狀態已變更',
        contractorAssigned: '已指派承包商',
        engineerAssigned: '已指派工程師',
        serviceAssigned: '已指派服務',
        priorityChanged: '優先順序已變更',
        actionableDateChanged: '可執行日期已變更',
        dueDateChanged: '到期日已變更',
        etaDateChanged: '預計抵達日期已變更',
        spendLimitApproved: '支出上限已核准',
        spendLimitCancelled: '支出上限申請已取消',
        spendLimitRejected: '支出上限已拒絕',
        spendLimitRequested: '已申請支出上限',
        jobSheetUploaded: '作業單已上傳',
        slaAlertSent: '已發送 SLA 警示',
        issuedWorkPermit: '已核發工作許可',
        requestForServiceSent: '已發送服務請求',
        comment: '已新增評論',
        unknown: '未知事件',
      },
      labels: {
        actionableDate: '可執行日期',
        comment: '評論',
        file: '檔案',
        contractor: '承包商',
        dueDate: '到期日',
        etaDate: '預計抵達日期',
        engineer: '工程師',
        priority: '優先順序',
        requestForService: '服務請求',
        service: '服務',
        spendLimit: '支出上限',
        status: '狀態',
        workPermit: '工作許可',
      },
    },
  },
}
